import {action,  observable, toJS} from 'mobx';
import { deviceMove } from '@/services/Home';
import DeviceStore from '@/stores/device';
import UserStore from '@/stores/user';
import log from '@/utils/log';

import * as R from 'ramda';
import {message} from 'antd';

class MoveStore {
  
  /* 要移动到的分组 */
  @observable activeGroupId: string | number;
  
  /* 过滤当前展开的id */
  @action.bound groupListFilter() {
  
    const isEven = (item: {id: number}) => {
      return item.id  !== UserStore.GroupStore.activeGroupId;
    }
  
    return R.filter(isEven, toJS(UserStore.GroupStore.groupList)).map((r:any) => ({id: r.id, name: r.groupName}));
  
  }
  
  @action async deviceMove () {
    
    const ids = DeviceStore.DeviceBaseStore.selectedCids.map((cid: string) =>
      R.find(R.propEq('cid', cid))(DeviceStore.DeviceBaseStore.deviceList
      )).map((r: any) => r.id);
  
    if (ids.length === 0 || !this.activeGroupId) {
      message.warning('请选择分组');
      return
    }
    
    const [error] = await deviceMove({ids: R.join(',',ids), groupId: this.activeGroupId});
    
    if (error) {
      log({ pageId: 'P09', eventId: 'E0903',  ext: ''})
      return false;
    }
  
    log({ pageId: 'P09', eventId: 'E0904',  ext: ''})
  
    message.success('移动成功');
    
    return true
  
  }
  
  @action.bound setGroupId (activeGroupId: string | number) {
    
    this.activeGroupId = activeGroupId;
    
  }
  
  
}

export default MoveStore;
